import { CTA } from "./components/cta";
import { Features } from "./components/features";
import { Footer } from "./components/footer";
import { Header } from "./components/header";
import { Hero } from "./components/hero";
import type { Route } from "./+types/_index";

export const meta: Route.MetaFunction = () => [{ title: "Worksheep" }];

export default function Index() {
  return (
    <div className="relative flex h-full w-full flex-col bg-secondary">
      <Header />
      <main className="flex-grow">
        <Hero />
        <Features />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
